import {
  Board,
  BoardHeader,
  BoardSearchDetail,
  BoardSearchResult,
  CalendarBox,
  CalendarIcon,
  ColSpan0,
  ColSpan1,
  ColTitle,
  CustomDatePicker,
  DateContainer,
  DeleteButton,
  GraySearchButton,
  RangePicker,
  RowSpan,
  Span1,
  selectStyle, ColSpan4, ColSpan2, mainColor, ChartTooltip, ChartContainer
} from "../../assets/GlobalStyles";
import Select from "react-select";
import ko from "date-fns/locale/ko";
import {HorizontalRule} from "../../components/common/Common";
import React, {useEffect, useMemo, useState} from "react";
import {
  getLastDay,
  getLastMonth,
  getLastNinetyDay,
  getLastThirtyDay,
  getLastWeekDay,
  getThisMonth,
  getToDay
} from "../../common/DateUtils";
import Table from "../../components/table";
import {
  deleteCustomReportsAxios,
  retrieveCommonReportsDetail, retrieveCommonReportsDetailByAdverCampId,
  retrieveCustomReportsDetail
} from "../../services/reports/ReportsAxios";
import {useAtom, useAtomValue} from "jotai";
import {reportsInfoAtom, tokenResultAtom} from "../login/entity/Common";
import {useLocation, useNavigate} from "react-router-dom";
import {dateFormat, decimalFormat, moneyToFixedFormat, numberToFixedFormat} from "../../common/StringUtils";
import {deviceType, productType, targetingType} from "../dash_board/entity/Common";
import {
  deleteCustomReportsAdminAxios,
  retrieveCommonReportsAdminDetail,
  retrieveCommonReportsAdminDetailByAdverCampId,
  retrieveCommonReportsAdminDetailByAdverId,
  retrieveCustomReportsAdminDetail
} from "../../services/reports/ReportsAdminAxios";
import {confirmAlert} from "react-confirm-alert";
import moment from "moment";
import {light} from "../../assets/theme";
import {css} from "styled-components";
import {
  summaryReducer,
  summaryReportReducer
} from "../dash_board/entity/Campaign";
import {lockedRows} from "./ReportsCampaign";
import {lockedReportRows} from "./entity/common";
import {
  selInventoryByAdminCampaign,
  selKeywordAdminCampaign,
  selKeywordCampaign,
  selKeywordUser
} from "../../services/Platform/ManageUserAxios";
import {ResponsiveLine} from "@nivo/line";
import {
  chartDataAtom,
  chartReportDataAtom,
  commonProperties
} from "../dash_board/entity/Chart";
import {ResponsiveBar} from "@nivo/bar";

function weekNumberByMonth(dateFormat) {
  const inputDate = new Date(dateFormat);

  // 인풋의 년, 월
  let year = inputDate.getFullYear();
  let month = inputDate.getMonth() + 1;

  // 목요일 기준 주차 구하기
  const weekNumberByThurFnc = (paramDate) => {

    const year = paramDate.getFullYear();
    const month = paramDate.getMonth();
    const date = paramDate.getDate();

    // 인풋한 달의 첫 날과 마지막 날의 요일
    const firstDate = new Date(year, month, 1);
    const lastDate = new Date(year, month+1, 0);
    const firstDayOfWeek = firstDate.getDay() === 0 ? 7 : firstDate.getDay();
    const lastDayOfweek = lastDate.getDay();

    // 인풋한 달의 마지막 일
    const lastDay = lastDate.getDate();

    // 첫 날의 요일이 금, 토, 일요일 이라면 true
    const firstWeekCheck = firstDayOfWeek === 5 || firstDayOfWeek === 6 || firstDayOfWeek === 7;
    // 마지막 날의 요일이 월, 화, 수라면 true
    const lastWeekCheck = lastDayOfweek === 1 || lastDayOfweek === 2 || lastDayOfweek === 3;

    // 해당 달이 총 몇주까지 있는지
    const lastWeekNo = Math.ceil((firstDayOfWeek - 1 + lastDay) / 7);

    // 날짜 기준으로 몇주차 인지
    let weekNo = Math.ceil((firstDayOfWeek - 1 + date) / 7);

    // 인풋한 날짜가 첫 주에 있고 첫 날이 월, 화, 수로 시작한다면 'prev'(전달 마지막 주)
    if(weekNo === 1 && firstWeekCheck) weekNo = 'prev';
    // 인풋한 날짜가 마지막 주에 있고 마지막 날이 월, 화, 수로 끝난다면 'next'(다음달 첫 주)
    else if(weekNo === lastWeekNo && lastWeekCheck) weekNo = 'next';
    // 인풋한 날짜의 첫 주는 아니지만 첫날이 월, 화 수로 시작하면 -1;
    else if(firstWeekCheck) weekNo = weekNo -1;

    return weekNo;
  };

  // 목요일 기준의 주차
  let weekNo = weekNumberByThurFnc(inputDate);

  // 이전달의 마지막 주차일 떄
  if(weekNo === 'prev') {
    // 이전 달의 마지막날
    const afterDate = new Date(year, month-1, 0);
    year = month === 1 ? year - 1 : year;
    month = month === 1 ? 12 : month - 1;
    weekNo = weekNumberByThurFnc(afterDate);
  }
  // 다음달의 첫 주차일 때
  if(weekNo === 'next') {
    year = month === 12 ? year + 1 : year;
    month = month === 12 ? 1 : month + 1;
    weekNo = 1;
  }

  return {year, month, weekNo};
}

const defaultColumn = {
  'BY_DAILY': {
    name: 'statisticsDate',
    header: '일별',
    type: 'number',
    sortable: true,
    textAlign: 'center',
    render: ({cellProps}) => {
      return <span><p>{dateFormat(cellProps.data.statisticsDate, 'yyyy년 MM월 DD일')}</p></span>
    },
    flex: 1
  },
  'BY_WEEKLY': {
    name: 'statisticsStartDate',
    header: '주별',
    textAlign: 'center',
    render: ({cellProps}) => {
      const weeks = weekNumberByMonth(cellProps.data.statisticsStartDate)
      return <span><p>{moment(cellProps.data.statisticsStartDate).format('MM월 DD일')}</p><p
        style={{color: '#999'}}>({weeks.month}월 {weeks.weekNo}주차)</p></span>
    },
    flex: 1
  },
  'BY_MONTHLY': {
    name: 'statisticsDate',
    header: '월별',
    textAlign: 'center',
    render: ({cellProps}) => {
      return <span><p>{dateFormat(cellProps.data.statisticsStartDate, 'yyyy년 MM월')} </p></span>
    },
    flex: 1
  },
  'adverName': {
    name: 'adverName',
    header: '광고주명',
    textAlign: 'center',
    render: (props) => {
      return <span>{props.value}</span>
    },
    flex: 1
  },
  'campaignName': {
    name: 'campaignName',
    header: '캠페인명',
    textAlign: 'center',
    flex: 1
  },
  'productName': {
    name: 'productType',
    header: '상품명',
    textAlign: 'center',
    render: ({value}) => {
      return <span>{productType.find(item => item.value === value)?.label}</span>
    },
    flex: 1
  },
  'targetingName': {
    name: 'targetingType',
    header: '타겟팅',
    textAlign: 'center',
    render: ({value}) => {
      return <span>{targetingType.find(item => item.value === value)?.label}</span>
    },
    flex: 1
  },
  'clickRate': {
    textAlign: 'center',
    render: (props) => {
      const clickRate = (props.data.validClickCount / props.data.exposureCount) * 100
      return <span className={'pct'}>{!isNaN(clickRate) ? numberToFixedFormat(clickRate) : 0}</span>
    },
    flex: 1
  },
  'cpc': {
    textAlign: 'center',
    render: (props) => {
      const cpc = props.data.costAmount / props.data.validClickCount
      return <span className={'won'}>{!isNaN(cpc) ? moneyToFixedFormat(cpc) : 0}</span>
    },
    flex: 1
  },
  'conversionRate': {
    textAlign: 'center',
    render: (props) => {
      const conversionRate = (props.data.conversionCount / props.data.totalClickCount) * 100
      return <span className={'pct'}>{!isNaN(conversionRate) ? numberToFixedFormat(conversionRate) : 0}</span>
    },
    flex: 1
  },
  'conversionPrice': {
    textAlign: 'center',
    render: (props) => {
      const costPerConversion = props.data.costAmount / props.data.conversionCount
      return <span className={'won'}>{!isNaN(costPerConversion) ? moneyToFixedFormat(costPerConversion) : 0}</span>
    },
    flex: 1
  },
  'amountPurchasedAvg': {
    textAlign: 'center',
    render: (props) => {
      const amountPurchased = (props.data.costAmount / props.data.conversionCount)
      return <span className={'won'}>{!isNaN(amountPurchased) ? moneyToFixedFormat(amountPurchased) : 0}</span>
    },
    flex: 1
  },
  'sessionConversionRoas': {
    textAlign: 'center',
    render: (props) => {
      const sessionRoas = (props.data.sessionConversionAmount / props.data.costAmount) * 100
      return <span className={'pct'}>{!isNaN(sessionRoas) ? numberToFixedFormat(sessionRoas) : 0}</span>
    },
    flex: 1
  },
  'directConversionRoas': {
    textAlign: 'center',
    render: (props) => {
      const directRoas = (props.data.directConversionAmount / props.data.costAmount) * 100
      return <span className={'pct'}>{!isNaN(directRoas) ? numberToFixedFormat(directRoas) : 0}</span>
    },
    flex: 1
  },
  'roas': {
    textAlign: 'center',
    render: (props) => {
      const roas = ((props.data.sessionConversionAmount + props.data.exposureConversionAmount + props.data.directConversionAmount) / props.data.costAmount) * 100
      return <span className={'pct'}>{!isNaN(roas) ? numberToFixedFormat(roas) : 0}</span>
    },
    flex: 1
  },
  'exposureConversionRoas': {
    textAlign: 'center',
    render: (props) => {
      const exposureRoas = (props.data.exposureConversionAmount / props.data.costAmount) * 100
      return <span className={'pct'}>{!isNaN(exposureRoas) ? numberToFixedFormat(exposureRoas) : 0}</span>
    },
    flex: 1
  },
  'eCpm': {
    header: 'CPV',
    type: 'number',
    sortable: false,
    textAlign: 'center',
    render: (props) => {
      const ecpm = (props.data.costAmount / props.data.exposureCount) * 1000
      return <span className={'won'} style={{color: '#5c5'}}>{!isNaN(ecpm) ? moneyToFixedFormat(ecpm) : 0}</span>
    },
    flex: 1
  },
  "exposureCount": {
    textAlign: 'center',
    type: 'number',
    sortable: true,
    render: ({value}) => {
      return <span>{decimalFormat(value)}</span>
    },
    flex: 1
  },
  "countByAdvertise": {
    textAlign: 'center',
    render: ({value}) => {
      return <span>{decimalFormat(value)}</span>
    },
    flex: 1
  },
  "validClickCount": {
    textAlign: 'center',
    render: ({value}) => {
      return <span>{decimalFormat(value)}</span>
    },
    flex: 1
  },
  "totalExposureCount": {
    textAlign: 'center',
    render: ({value}) => {
      return <span>{decimalFormat(value)}</span>
    },
    flex: 1
  },
  "conversionCount": {
    textAlign: 'center',
    render: ({value}) => {
      return <span>{decimalFormat(value)}</span>
    },
    flex: 1
  },
  "directConversionAmount": {
    textAlign: 'center',
    render: ({value}) => {
      return <span className={'won'}>{moneyToFixedFormat(value)}</span>
    },
    flex: 1
  },
  "sessionConversionAmount": {
    textAlign: 'center',
    render: ({value}) => {
      return <span className={'won'}>{moneyToFixedFormat(value)}</span>
    },
    flex: 1
  },
  "totalClickCount": {
    textAlign: 'center',
    render: ({value}) => {
      return <span>{decimalFormat(value)}</span>
    },
    flex: 1
  },
  "exposureConversionAmount": {
    textAlign: 'center',
    render: ({value}) => {
      return <span className={'won'}>{moneyToFixedFormat(value)}</span>
    },
    flex: 1
  },
  "costAmount": {
    textAlign: 'center',
    type: 'number',
    sortable: true,
    render: ({value}) => {
      return <span className={'won'} style={{color: '#c55'}}>{decimalFormat(value)}</span>
    },
    flex: 1
  }
}

export default function ReportsPeriod() {
  const mainColor = light.color.topicColor;
  const [searchCondition, setSearchCondition] = useState({
    pageSize: 31,
    currentPage: 1,
    searchStartDate: getThisMonth().startDay,
    searchEndDate: getToDay(),
    productType: null,
    deviceType: null,
    inventoryId: ""
  })
  const [adverList, setAdverList] = useState([{
    key: 0,
    value: '',
    label: '전체'
  }]);
  const [campaignList, setCampaignList] = useState([{
    key: 0,
    value: '',
    label: '전체'
  }]);
  const [inventoryList, setInventoryList] = useState([{
    key: 0,
    value: '',
    label: '전체'
  }]);
  const [dateActive,setDateActive] = useState('thisMonth');
  const [dateRange, setDateRange] = useState([ new Date(getThisMonth().startDay), new Date(getToDay())]);
  const [startDate, endDate] = dateRange;
  const tokenResult = useAtomValue(tokenResultAtom);
  const [campaignColumn, setCampaignColumn] = useState([]);
  const [campaignData, setCampaignData] = useState([]);
  const [selectedAdver, setSelectedAdver] = useState('');
  const [selectedAdverCamp, setSelectedAdverCamp] = useState('');
  const [selectedInventory, setSelectedInventory] = useState('');
  const [reportSettingInfo, setReportSettingInfo] = useState({});
  const navigate = useNavigate();
  const [chartList, setChartList] = useState([]);
  const [chartData, setChartData] = useState(chartReportDataAtom);
  const [chartDataInfo, setChartDataInfo] = useState([])
  const [reportsInfo, setReportsInfo] = useAtom(reportsInfoAtom);

  useEffect(() => {
    if(reportsInfo.id === null) return navigate('/board/reports')
    if(tokenResult?.role !== "NORMAL") {
      retrieveCommonReportsAdminDetail(tokenResult?.id, searchCondition, 'period').then(response => {
        if(response){
          let newObject = response?.adminSetting.groupByPeriod !== 'NONE' ? [defaultColumn[reportsInfo.groupBy]].concat(response.headers) : [].concat(response.headers)
          newObject.map((item, key) => {
            Object.assign(newObject[key], defaultColumn[item.name])
            return null
          })
          setCampaignColumn(newObject)
          setCampaignData(response?.pagingCommonResponse.content)
          setReportSettingInfo(response?.adminSetting)
        }
      })
    } else {
      retrieveCommonReportsDetail(tokenResult?.id, searchCondition, 'period').then(response => {
        if(response) {
          let newObject =  response?.userSetting.groupByPeriod !== 'NONE' ? [defaultColumn[reportsInfo.groupBy]].concat(response.headers) : [].concat(response.headers)
          newObject.map((item, key) => {
            Object.assign(newObject[key], defaultColumn[item.name])
            return null
          })
          setCampaignColumn(newObject)
          setCampaignData(response.pagingCommonResponse.content)
          setReportSettingInfo(response.userSetting)
        }
      })
    }
    return () => {
      setDateActive('thisMonth')
      setDateRange([ new Date(getThisMonth().startDay), new Date(getToDay())])
      setSearchCondition({
        pageSize: 31,
        currentPage: 1,
        searchStartDate: getThisMonth().startDay,
        searchEndDate: getToDay(),
        productType: null,
        deviceType:  null
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenResult, reportsInfo.id]);

  useEffect(() => {

    if(tokenResult.role !== "NORMAL") {
      selKeywordUser('').then(response => {
        const options = response?.map(item => ({
          key: item.id,
          value: item.id,
          label: item.adverName
        }));

        setAdverList([
          {
            key: 0,
            value: '',
            label: '전체'
          },
          ...options
        ]);
      })
    } else {
      setSelectedAdver(tokenResult.id);
    }
  }, []);

  useEffect(() => {
    if(selectedAdver == null) return;
    if(selectedAdver === undefined) return;
    if(selectedAdver === '') return;

    if(tokenResult.role !== "NORMAL") {
      selKeywordAdminCampaign(selectedAdver, '').then(response => {
        const options = response?.map(item => ({
          key: item.id,
          value: item.id,
          label: item.campName
        }));

        setCampaignList([
          {
            key: 0,
            value: '',
            label: '전체'
          },
          ...options
        ]);
      })
    } else {
      selKeywordCampaign(selectedAdver, '').then(response => {
        const options = response?.map(item => ({
          key: item.id,
          value: item.id,
          label: item.campName
        }));

        setCampaignList([
          {
            key: 0,
            value: '',
            label: '전체'
          },
          ...options
        ]);
      })
    }
  }, [selectedAdver]);

  useEffect(() => {
    if(selectedAdverCamp == null) return;
    if(selectedAdverCamp === undefined) return;
    if(selectedAdverCamp === '') return;

    if(tokenResult.role !== "NORMAL") {
      selInventoryByAdminCampaign(selectedAdverCamp).then(response => {
        const options = response?.map(item => ({
          key: item.inventoryId,
          value: item.inventoryId,
          label: item.inventoryName
        }));

        setInventoryList([
          {
            key: 0,
            value: '',
            label: '전체'
          },
          ...options
        ]);
      })
    }
  }, [selectedAdverCamp]);

  useEffect(() => {
    makeChartInfo(campaignData);
  }, [campaignData]);

  useEffect(() => {
    makeChartData();
  }, [chartDataInfo, chartData]);

  const sortedCampaignData = useMemo(() => {
    return [...(campaignData || [])].sort((a, b) => {
      if (!a.statisticsDate && !b.statisticsDate) return 0;
      if (!a.statisticsDate) return 1;
      if (!b.statisticsDate) return -1;

      return b.statisticsDate.localeCompare(a.statisticsDate);
    });
  }, [campaignData]);
  const yFormatted = (id, value) => {
    if (['clickRate', 'conversionRate', 'sessionRoas', 'directRoas', 'totalRoas'].includes(id)) {
      return numberToFixedFormat(value) + '%';
    }

    if ([
      'validClickCount',
      'exposureCount',
      'totalConversionCount',
      'userCount',
      'totalExposureCount',
      'totalClickCount',
      'allowInventorys'
    ].includes(id)) {
      return decimalFormat(value);
    }

    return moneyToFixedFormat(value) + '원';
  };
  function _toYmd(d) {
    const yyyy = d.getFullYear()
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    return `${yyyy}-${mm}-${dd}`
  }

  function _parseToDate(v) {
    if (!v) return null
    // 'YYYY-MM-DD' 또는 Date 모두 대응
    if (v instanceof Date) return v
    return new Date(String(v).slice(0, 10))
  }
  function fillMissingDailyRows(rows, searchCondition) {

    const src = Array.isArray(rows) ? rows : []
    if (src.length === 0) return src

    const key = 'statisticsDate'
    const from = _parseToDate(searchCondition?.searchStartDate)
    const to = _parseToDate(searchCondition?.searchEndDate)

    let minD = from
    let maxD = to

    if (!minD || !maxD) {
      const dates = src
      .map(r => _parseToDate(r?.[key]))
      .filter(Boolean)
      .sort((a, b) => a - b)

      minD = minD || dates[0]
      maxD = maxD || dates[dates.length - 1]
    }

    if (!minD || !maxD) return src

    // ✅ 합산 대상 필드(원본 + 파생지표 포함 가능)
    const sumFields = [
      'exposureCount',
      'totalExposureCount',
      'validClickCount',
      'totalClickCount',
      'sessionConversionCount',
      'directConversionCount',
      'exposureConversionCount',
      'totalConversionCount',
      'costAmount',
      'sessionConversionAmount',
      'directConversionAmount',
      'exposureConversionAmount',
      'totalConversionAmount',
      // 파생지표를 rows에 이미 넣어놨다면, 여기 합산은 비추천(재계산이 맞음)
      // 'clickRate', 'cpc', ...
    ]

    const byYmd = new Map()

    // ✅ 같은 날짜면 누적 합산
    for (const r of src) {
      const d = _parseToDate(r?.[key])
      if (!d) continue
      const ymd = _toYmd(d)

      const prev = byYmd.get(ymd)
      if (!prev) {
        const base = {
          ...r,
          [key]: ymd,
        };

        for (const f of sumFields) {
          base[f] = Number(base[f] ?? 0);
        }

        byYmd.set(ymd, base);
        continue;
      }

      // 누적
      for (const f of sumFields) {
        prev[f] = Number(prev[f] ?? 0) + Number(r?.[f] ?? 0)
      }

      const seen = new Set();
    }

    const out = []
    for (let d = new Date(minD); d <= maxD; d.setDate(d.getDate() + 1)) {
      const ymd = _toYmd(d)
      const hit = byYmd.get(ymd)

      if (hit) {
        out.push(hit)
      } else {
        out.push({
          [key]: ymd,
          exposureCount: 0,
          totalExposureCount: 0,
          validClickCount: 0,
          totalClickCount: 0,
          sessionConversionCount: 0,
          directConversionCount: 0,
          exposureConversionCount: 0,
          totalConversionCount: 0,
          costAmount: 0,
          sessionConversionAmount: 0,
          directConversionAmount: 0,
          exposureConversionAmount: 0,
          totalConversionAmount: 0,
        })
      }
    }

    return out
  }

  const makeChartInfo = (overviewCache) => {
    let data = overviewCache  ?? [];

    const filled = fillMissingDailyRows(data, searchCondition);

    const computed = filled.map(item => {
      const exposureCount = item.exposureCount ?? 0
      const validClickCount = item.validClickCount ?? 0
      const costAmount = item.costAmount ?? 0
      const totalConversionCount = item.totalConversionCount ?? 0
      const totalConversionAmount = item.totalConversionAmount ?? 0
      const sessionConversionAmount = item.sessionConversionAmount ?? 0
      const directConversionAmount = item.directConversionAmount ?? 0
      return {
        ...item,
        clickRate: exposureCount !== 0 ? (validClickCount / exposureCount) * 100 : 0,
        cpc: validClickCount !== 0 ? costAmount / validClickCount : 0,
        costPerConversion: totalConversionCount !== 0 ? costAmount / totalConversionCount : 0,
        avgConversionAmount: totalConversionCount !== 0 ? totalConversionAmount / totalConversionCount : 0,
        sessionRoas: costAmount !== 0 ? (sessionConversionAmount / costAmount) * 100 : 0,
        directRoas: costAmount !== 0 ? (directConversionAmount / costAmount) * 100 : 0,
        totalRoas: costAmount !== 0 ? (totalConversionAmount / costAmount) * 100 : 0,
        ecpm: exposureCount !== 0 ? (costAmount / exposureCount) * 1000 : 0,
        conversionRate: validClickCount !== 0 ? (totalConversionCount / validClickCount) * 100 : 0,
      }
    });
    setChartDataInfo(computed)
  }

  const fixedColors = ['#1A73E8', '#D93025', '#1E8E3E', '#F9AB00', '#7325D9'];
  const makeChartData = () => {
    const activeKeys = Object.keys(chartData).filter(id => chartData[id].status);

    const list = chartDataInfo.map(item => {
      const date = new Date(item?.statisticsDate);
      const formattedDate = dateFormat(date, 'MM/DD');

      const row = {
        date: formattedDate,
        tooltipDate: dateFormat(date, 'YYYY.MM.DD'),
      };

      activeKeys.forEach(id => {
        row[id] = isNaN(Number(item[id])) ? 0 : Number(item[id]);
      });

      return row;
    });

    setChartList(list);
  };
  /**
   * 날짜 직접 변경
   */
  const handleChangeDate = (date) => {
    setDateRange(date)
    if(date[1] !== null){
      setSearchCondition({
        ...searchCondition,
        searchStartDate: moment(date[0]).format('YYYY-MM-DD'),
        searchEndDate: moment(date[1]).format('YYYY-MM-DD'),
      })
    }
  }
  /**
   * 날짜 레인지 선택
   * @param rangeType
   */
  const handleRangeDate = (rangeType) => {
    setDateActive(rangeType)
    if (rangeType === 'thisMonth') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getThisMonth().startDay,
        searchEndDate: getThisMonth().endDay,
        pageSize: 31
      })
      setDateRange([new Date(getThisMonth().startDay), new Date(getThisMonth().endDay)])
    } else if (rangeType === 'lastMonth') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastMonth().startDay,
        searchEndDate: getLastMonth().endDay,
        pageSize: 31,
      })
      setDateRange([new Date(getLastMonth().startDay), new Date(getLastMonth().endDay)])
    } else if (rangeType === 'today') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getToDay(),
        searchEndDate: getToDay(),
        pageSize: 1
      })
      setDateRange([new Date(), new Date()])
    } else if (rangeType === 'lastDay') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastDay(),
        searchEndDate: getLastDay(),
        pageSize: 1
      })
      setDateRange([new Date(getLastDay()), new Date(getLastDay())])
    } else if (rangeType === 'lastWeekDay') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastWeekDay().startDay,
        searchEndDate: getLastWeekDay().endDay,
        pageSize: 7
      })
      setDateRange([new Date(getLastWeekDay().startDay), new Date(getLastWeekDay().endDay)])
    } else if (rangeType === 'lastThirtyDay') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastThirtyDay().startDay,
        searchEndDate: getLastThirtyDay().endDay,
        pageSize: 30
      })
      setDateRange([new Date(getLastThirtyDay().startDay), new Date(getLastThirtyDay().endDay)])
    } else if (rangeType === 'lastNinetyDay') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastNinetyDay().startDay,
        searchEndDate: getLastNinetyDay().endDay,
        pageSize: 90
      })
      setDateRange([new Date(getLastNinetyDay().startDay), new Date(getLastNinetyDay().endDay)])
    }
    //call 때려
  }
  /**
   * 광고상품
   * @param event
   */
  const handleChangeProduct = (event) => {
    setSearchCondition({
      ...searchCondition,
      productType: event.value
    })
  }
  /**
   * 디바이스 서치
   * @param event
   */
  const handleChangeDevice = (event) => {
    console.log(event.value)
    setSearchCondition({
      ...searchCondition,
      deviceType: event.value
    })
  }

  /**
   * 광고주 선택
   * @param event
   */
  const handleSelectAdver = (event) => {
    setSelectedAdver(event.value);
    setSelectedAdverCamp('');
  }

  /**
   * 캠페인 선택
   * @param event
   */
  const handleSelectAdverCamp = (event) => {
    setSelectedAdverCamp(event.value);
    setSelectedInventory("");
    setSearchCondition({
      ...searchCondition,
      inventoryId: ""
    })
  }

  /**
   * 지면 선택
   * @param event
   */
  const handleSelectMediaInven = (event) => {
    setSelectedInventory(event.value);
    setSearchCondition({
      ...searchCondition,
      inventoryId: event.value
    })
  }
  /**
   * 검색
   */
  const handleSearchReports = () => {
    if(tokenResult.role !== "NORMAL") {
      if(selectedAdver !== '') {
        if(selectedAdverCamp !== ''){
          retrieveCommonReportsAdminDetailByAdverCampId(tokenResult.id, searchCondition, 'campaign_daily', selectedAdver, selectedAdverCamp).then(response => {
            setCampaignData(response.pagingCommonResponse.content)
          })
        } else {
          retrieveCommonReportsAdminDetailByAdverId(tokenResult.id, searchCondition, 'adver_daily', selectedAdver, '').then(response => {
            setCampaignData(response.pagingCommonResponse.content)
          })
        }
      } else {
        retrieveCommonReportsAdminDetail(tokenResult.id, searchCondition, 'period').then(response => {
          setCampaignData(response.pagingCommonResponse.content)
        })
      }
    }else {

      if(selectedAdverCamp !== '') {
        retrieveCommonReportsDetailByAdverCampId(tokenResult.id, searchCondition, 'campaign_daily', selectedAdverCamp).then(response => {
          setCampaignData(response.pagingCommonResponse.content)
        })
      } else {
        retrieveCommonReportsDetail(tokenResult.id, searchCondition,
            'period').then(response => {
          setCampaignData(response.pagingCommonResponse.content)
        })
      }
    }
  }

  return(<>
    <Board>
      <BoardHeader>{`일자별 보고서`}</BoardHeader>
        <BoardSearchDetail>
          <RowSpan style={{justifyContent: 'flex-start'}}>
            {
              (tokenResult?.role !== "NORMAL") &&
              <ColSpan1>
                <ColTitle><span>광고주</span></ColTitle>
                <Select options={adverList}
                        defaultValue={adverList[0]}
                        value={adverList.find(item => item.value === selectedAdver)}
                        onChange={handleSelectAdver}
                        styles={selectStyle}
                        isSearchable={false}
                />
              </ColSpan1>
            }
            <ColSpan2 padding={(tokenResult?.role !== "NORMAL") && 50}>
              <ColTitle><span>캠페인</span></ColTitle>
              <Select
                  isDisabled={selectedAdver === '' || selectedAdver === null}
                  options={campaignList}
                      defaultValue={campaignList[0]}
                      value={campaignList.find(item => item.value === selectedAdverCamp)}
                      onChange={handleSelectAdverCamp}
                      styles={selectStyle}
                      isSearchable={false}
              />
            </ColSpan2>
            {tokenResult?.role !== "NORMAL" &&
              <ColSpan2 padding={(tokenResult?.role !== "NORMAL") && 50}>
                <ColTitle><span>지면</span></ColTitle>
                <Select
                    isDisabled={selectedAdverCamp === '' || selectedAdverCamp === null}
                    options={inventoryList}
                    defaultValue={inventoryList[0]}
                    value={inventoryList.find(item => item.value === selectedInventory)}
                    onChange={handleSelectMediaInven}
                    styles={selectStyle}
                    isSearchable={false}
                />
              </ColSpan2>
            }
          </RowSpan>
          <RowSpan style={{justifyContent: 'flex-start'}}>
            <ColSpan1>
              <ColTitle><span>광고 상품</span></ColTitle>
              <Select options={productType}
                      defaultValue={productType[0]}
                      value={productType.find(item => item.value === searchCondition.productType)}
                      onChange={handleChangeProduct}
                      styles={selectStyle}
                      isSearchable={false}
              />
              {/*<Select styles={selectStyle} defaultValue={productType[0]} options={productType} onChange={handleChangeProduct} value={productType.find(item => item.value === searchCondition.productType)}/>*/}
            </ColSpan1>
            <ColSpan1 padding={50}>
              <ColTitle><span>디바이스</span></ColTitle>
              <Select options={deviceType}
                      defaultValue={deviceType[0]}
                      value={deviceType.find(item => item.value === searchCondition.deviceType)}
                      onChange={handleChangeDevice}
                      styles={selectStyle}
                      isSearchable={false}
              />
              {/*<div style={{width: '100px'}}>*/}
              {/*  <Select styles={selectStyle} defaultValue={deviceType[0]} options={deviceType} onChange={handleChangeDevice} value={deviceType.find(item => item.value === searchCondition.deviceType)}/>*/}
              {/*</div>*/}
            </ColSpan1>
          </RowSpan>
          <RowSpan>
            <ColSpan1>
              <ColTitle><span>기간</span></ColTitle>
              <div style={{width:'100%'}}>
                <DateContainer>
                  <CalendarBox>
                    <CalendarIcon/>
                  </CalendarBox>
                  <CustomDatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(date) => handleChangeDate(date)}
                    dateFormat="yyyy-MM-dd"
                    maxDate={new Date()}
                    locale={ko}
                    isClearable={false}
                    monthsShown={2}
                    openToDate={endDate}
                  />
                </DateContainer>
              </div>
            </ColSpan1>
            <ColSpan2>
              <div>
                <RangePicker>
                  <div onClick={() => handleRangeDate('thisMonth')} style={dateActive==='thisMonth'?{color:mainColor, fontWeight:"bold"}:null}>이번달</div>
                  <HorizontalRule style={{margin: "0 10px"}}/>
                  <div onClick={() => handleRangeDate('lastMonth')} style={dateActive==='lastMonth'?{color:mainColor, fontWeight:"bold"}:null}>지난달</div>
                  <HorizontalRule style={{margin: "0 10px"}}/>
                  <div onClick={() => handleRangeDate('today')} style={dateActive==='today'?{color: mainColor, fontWeight:"bold"}:null}>오늘</div>
                  <HorizontalRule style={{margin: "0 10px"}}/>
                  <div onClick={() => handleRangeDate('lastDay')} style={dateActive==='lastDay'?{color:mainColor, fontWeight:"bold"}:null}>어제</div>
                  <HorizontalRule style={{margin: "0 10px"}}/>
                  <div onClick={() => handleRangeDate('lastWeekDay')} style={dateActive==='lastWeekDay'?{color:mainColor, fontWeight:"bold"}:null}>지난7일</div>
                  <HorizontalRule style={{margin: "0 10px"}}/>
                  <div onClick={() => handleRangeDate('lastThirtyDay')} style={dateActive==='lastThirtyDay'?{color:mainColor, fontWeight:"bold"}:null}>지난30일</div>
                  <HorizontalRule style={{margin: "0 10px"}}/>
                  <div onClick={() => handleRangeDate('lastNinetyDay')} style={dateActive==='lastNinetyDay'?{color:mainColor, fontWeight:"bold"}:null}>지난90일</div>
                </RangePicker>
              </div>
            </ColSpan2>
          <ColSpan1>
            <GraySearchButton onClick={handleSearchReports}>적용</GraySearchButton>
          </ColSpan1>
        </RowSpan>
              {/*<ValidationGroup>*/}
              {/*  <DefaultButton onClick={handleSearchReports}>검색</DefaultButton>*/}
              {/*</ValidationGroup>*/}
      </BoardSearchDetail>
    </Board>
        <Board>
        <ChartContainer>
          <div style={{height: 300}}>
            {chartList.length !== 0 &&
                <ResponsiveBar
                    data={chartList}
                    keys={Object.keys(chartData).filter(id => chartData[id].status)}
                    indexBy="date"
                    margin={{ top: 20, right: 30, bottom: 50, left: 70 }}
                    padding={0.3}
                    groupMode="grouped"
                    valueScale={{ type: 'linear' }}
                    indexScale={{ type: 'band', round: true }}
                    colors={{ scheme: 'nivo' }}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: -45,
                    }}
                    axisLeft={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      format: value => decimalFormat(value),
                    }}
                    enableLabel={false}
                    tooltip={({ id, value, color, data }) => {
                      return (
                          <ChartTooltip>
                            <p className={'date'}>{data.tooltipDate}</p>
                            <p>
            <span style={{ color }}>
              {chartData[id]?.label} :
            </span>
                              <span>{yFormatted(id, value)}</span>
                            </p>
                          </ChartTooltip>
                      );
                    }}
                    legends={[]}
                    role="application"
                />
            }
          </div>
        </ChartContainer>
        </Board>
    <Board>
      <BoardSearchResult>
        <Table
          style={{fontSize: 13, minHeight: campaignData?.length !== 0 ? 550 : 300}}
          headerHeight={40}
          downloadList={true}
          lockedRows={lockedReportRows}
          summaryReducer={summaryReportReducer}
          totalCount={[campaignData?.length, '보고서']}
          columns={campaignColumn}
          data={sortedCampaignData}
          fileName={'일자별_보고서'}
          defaultSortInfo={{field:"statisticsDate", dir: -1}}
          enableColumnAutosize={true}
          idProperty={'statisticsDate'}
        />
      </BoardSearchResult>
    </Board></>
  )
}
